import React from 'react';
import { SubMenuLink } from "../../SubMenuLink";

const Notifications = () => {
  return <SubMenuLink pathname="/notifications" title="Notifications list" icon="NOTIFICATIONS_LIGHT" />
};

export default Notifications;